import React from 'react'

interface Props {
  dark?: boolean
  narrow?: boolean
}

const Divider: React.FC<Props> = ({ dark, narrow }: Props) => (
  <hr
    role="separator"
    className={`${
      dark ? 'border-black dark:border-gray-border-dm' : 'border-white'
    } border-opacity-20 ${narrow ? 'my-2' : 'my-4'}`}
  />
)

export default Divider
